import PdvSalesReportsAPI from '../../api/pdvSalesReports';

const state = {
  summary: {
    total_revenue: 0,
    total_sales: 0,
    avg_ticket: 0,
    total_discount: 0,
    avg_delivery_fee: 0,
    timeseries: [],
  },
  agents: [],
  products: [],
  payments: [],
  productAgents: [],
  uiFlags: {
    isFetchingSummary: false,
    isFetchingAgents: false,
    isFetchingProducts: false,
    isFetchingPayments: false,
    isFetchingProductAgents: false,
  },
};

const getters = {
  getSummary: s => s.summary,
  getAgents: s => s.agents,
  getProducts: s => s.products,
  getPayments: s => s.payments,
  getProductAgents: s => s.productAgents,
  getUIFlags: s => s.uiFlags,
};

const mutations = {
  SET_SUMMARY(s, data) {
    s.summary = data;
  },
  SET_AGENTS(s, data) {
    s.agents = data;
  },
  SET_PRODUCTS(s, data) {
    s.products = data;
  },
  SET_PAYMENTS(s, data) {
    s.payments = data;
  },
  SET_PRODUCT_AGENTS(s, data) {
    s.productAgents = data;
  },
  SET_UI_FLAG(s, { key, value }) {
    s.uiFlags[key] = value;
  },
};

const actions = {
  async fetchSummary({ commit }, params) {
    commit('SET_UI_FLAG', { key: 'isFetchingSummary', value: true });
    try {
      const { data } = await PdvSalesReportsAPI.getSummary(params);
      commit('SET_SUMMARY', data);
    } catch {
      // silent
    } finally {
      commit('SET_UI_FLAG', { key: 'isFetchingSummary', value: false });
    }
  },
  async fetchAgents({ commit }, params) {
    commit('SET_UI_FLAG', { key: 'isFetchingAgents', value: true });
    try {
      const { data } = await PdvSalesReportsAPI.getAgents(params);
      commit('SET_AGENTS', data);
    } catch {
      // silent
    } finally {
      commit('SET_UI_FLAG', { key: 'isFetchingAgents', value: false });
    }
  },
  async fetchProducts({ commit }, params) {
    commit('SET_UI_FLAG', { key: 'isFetchingProducts', value: true });
    try {
      const { data } = await PdvSalesReportsAPI.getProducts(params);
      commit('SET_PRODUCTS', data);
    } catch {
      // silent
    } finally {
      commit('SET_UI_FLAG', { key: 'isFetchingProducts', value: false });
    }
  },
  async fetchPayments({ commit }, params) {
    commit('SET_UI_FLAG', { key: 'isFetchingPayments', value: true });
    try {
      const { data } = await PdvSalesReportsAPI.getPayments(params);
      commit('SET_PAYMENTS', data);
    } catch {
      // silent
    } finally {
      commit('SET_UI_FLAG', { key: 'isFetchingPayments', value: false });
    }
  },
  async fetchProductAgents({ commit }, params) {
    commit('SET_UI_FLAG', { key: 'isFetchingProductAgents', value: true });
    try {
      const { data } = await PdvSalesReportsAPI.getProductAgents(params);
      commit('SET_PRODUCT_AGENTS', data);
    } catch {
      // silent
    } finally {
      commit('SET_UI_FLAG', { key: 'isFetchingProductAgents', value: false });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
